export default __webpack_public_path__ + "static/media/car.42e709d5.svg";